import { Loading_ellipsis } from "../../loading";
import style from "./ProgressBar.module.scss";

function UploadProgress({ progress, dictionary, isAdaptive = false }) {
	return (
		<div id="upload-progress" className={`${style.progress_wrapper} ${isAdaptive ? style.adaptive : style["adaptive-none"]}`}>
			<p className={style.progress_number}>{progress}%</p>
			<div className={style.progress_line}>
				<div className={style.progress} style={{ width: `${progress}%` }}></div>
			</div>
			<div className={style.progress_text}>
				<span dangerouslySetInnerHTML={{ __html: `${dictionary["Sending file to a server"]}` }} />
				<Loading_ellipsis />
			</div>
		</div>
	);
}

export default UploadProgress;
